<template>
  <!--
  PRK 2LKM4LCLCB252
  -->
  
  <van-popover :placement="popOverPlacement" v-model:show="showPopoverBtnRef" :actions="actions" >
    <template #reference>
  
  <van-button @mouseover="showPopoverBtnRef = true" plain @mouseleave="showPopoverBtnRef = false"  @click="varShowPopUpSession = true" class="btn-add-prk" size="small" type="primary">
    <van-icon name="plus" /> {{ $t('Session') }}  
  </van-button>
  
  </template>
  </van-popover>
  
  <van-popup  closeable  v-model:show="varShowPopUpSession" position="bottom" v-bind:class="{ van_popup_choose_gigamedia : envWebName == 'Site Gigamedia' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }" >
  
   <h3 class="align-center">{{ $t('Ajouter les configurations') }} </h3>
   <van-field v-on:keyup.enter="addRefDevis" :disabled="LoadAddRefDisabled" v-model="numSession" class="grand_label input_prk all_border_radius"  center clearable :label="$t('N° de session')" :placeholder="$t('N° de session')">
      <template #button>
        <van-button :disabled="LoadAddRefDisabled" @click="addRefDevis"  size="small" type="primary">{{ $t('Ajouter') }} </van-button>
      </template>
    </van-field>
    <Spinner style="margin-top: 90px;" v-if="LoadAddRefDisabled"/>
  
  </van-popup>
  
    <br/>
      </template>
      
      <script>
       import Spinner from '../../loader/Spinner.vue'
      export default {
        props: ['popOverPlacement'],
        components: {
          Spinner,
        },
        data() {
          return {
            
            actions : [
        { text: this.$t('Ajouter les configurations') },
      ],
            LoadAddRefDisabled : false ,
            showPopoverBtnRef : false ,
            varShowPopUpSession: false,
             // numDevis : '113794-0' ,
              numSession : '' ,
              envWebName : false
  
          }
        },
        mounted(){
          this.envWebName = this.$store.state.storeGlobal.StoreEnvWeb
        },
        computed: {
      
        },
        created() {
          
            },
        methods:{
          async addRefDevis(){ 
            this.LoadAddRefDisabled = true;

var requestRefIntoSession = await this.globalFunctionPrePanier.getReferenceIntoSession(this.numSession, this);

// Vérifie si requestRefIntoSession est un tableau ou un objet et procède à la vérification de la longueur/du nombre de clés en conséquence
let length = Array.isArray(requestRefIntoSession) ? requestRefIntoSession.length : Object.keys(requestRefIntoSession).length;

if (length === 0) {
  this.LoadAddRefDisabled = false;
  this.numSession = '';
} else {
  // Si requestRefIntoSession est un tableau
  if (Array.isArray(requestRefIntoSession)) {
    for (let i = 0; i < requestRefIntoSession.length; i++) {
      if (requestRefIntoSession[i].etat_session == true) {
        this.refPrk = requestRefIntoSession[i].reference;
        await this.globalFunctionPrePanier.ajoutPrkInPanier(this);
      }
    }
  } else {
    // Si requestRefIntoSession est un objet
    for (let key in requestRefIntoSession) {
      if (requestRefIntoSession[key].etat_session == true) {
        this.refPrk = requestRefIntoSession[key].reference;
        await this.globalFunctionPrePanier.ajoutPrkInPanier(this);
      }
    }
  }
  this.numSession = '';
  this.varShowPopUpSession = false;
  this.LoadAddRefDisabled = false;
}

            
          },
        }
      
         
      }
      
      </script>
      
      <style>
      
      </style>
      
      